<template>
  <div
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="basicModal"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered"
      role="document"
    >
      <div class="modal-content">
        <div
          v-if="loading && typeof quickViewItem.titulo === 'undefined'"
          class="align-self-md-center qwpt"
        >
          <socket></socket>
        </div>
        <div
          v-else
          id="quickview"
        >
          <div :class="'quickview-box ' + quickViewItem.extraClass">
            <div class="row">
              <div class="col-12 col-md-5 align-self-md-center position-relative">
                <div class="d-flex mb-4">
                  <h5
                    class="product-type color-type col-lg-6 p-0"
                    v-text="quickViewItem.marca"
                  ></h5>
                  <h5
                    class="col-sm-12 col-md-7 col-lg-6 color-type d-inline-block p-0 product-type text-right"
                    v-text="quickViewItem.categoria"
                  ></h5>
                </div>
                <div class="shop-detail_img vh-47">
                  <div class="big-img big-img_qv">
                    <div class="big-img_block border-new overflow-hidden vh-45">
                      <img
                        :src="quickViewItem.imagem"
                        :alt="quickViewItem.titulo"
                        style="max-width: 41vh; max-height: 41vh;"
                      >
                    </div>
                  </div>
                </div>
                <div
                  v-if="!showReactions"
                  class="row col-lg-6 col-md-6 col-sm-12"
                >
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Status:</label>
                      <switch-input
                        v-model="quickViewItem.status"
                        icon-size="3"
                        v-on:click="setColumn('status')"
                      ></switch-input>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Verificado:</label>
                      <switch-input
                        v-model="quickViewItem.verificado"
                        icon-size="3"
                        v-on:click="setColumn('verificado')"
                      ></switch-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-7 mt-xl-5">
                <div class="col-12 p-0">
                  <div class="d-flex">
                    <div
                      v-if="quickViewItem.verificado"
                      class="mr-1"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="19pt"
                        height="19pt"
                        viewBox="0 0 19 19"
                        version="1.1"
                        fill="rgba(11, 125, 0, 1)"
                      >
                        <title>Item Verificado</title>
                        <g id="surface1">
                          <path d="M 19 9.5 L 16.847656 7.113281 L 17.1875 3.914062 L 14.039062 3.25 L 12.4375 0.460938 L 9.5 1.773438 L 6.5625 0.460938 L 4.960938 3.25 L 1.8125 3.914062 L 2.152344 7.113281 L 0 9.5 L 2.152344 11.886719 L 1.8125 15.085938 L 4.960938 15.75 L 6.5625 18.539062 L 9.5 17.226562 L 12.4375 18.539062 L 14.039062 15.75 L 17.1875 15.085938 L 16.847656 11.886719 Z M 13.484375 7.417969 L 8.714844 12.761719 L 5.398438 9.449219 L 6.1875 8.660156 L 8.667969 11.140625 L 12.652344 6.675781 Z M 13.484375 7.417969 " />
                        </g>
                      </svg>
                    </div>
                    <div
                      v-if="quickViewItem.tipo_beneficio === 'V'"
                      class="icon_tipo_beneficio icon_position"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="22pt"
                        height="22pt"
                        viewBox="0 0 25 25"
                        version="1.1"
                      >
                        <g id="surface1">
                          <path d="M 24.191406 3.757812 L 0.808594 3.757812 C 0.363281 3.757812 0 4.121094 0 4.566406 L 0 20.433594 C 0 20.878906 0.363281 21.242188 0.808594 21.242188 L 24.191406 21.242188 C 24.636719 21.242188 25 20.878906 25 20.433594 L 25 4.566406 C 25 4.121094 24.636719 3.757812 24.191406 3.757812 Z M 24.21875 17.117188 L 22.9375 17.117188 C 22.722656 17.117188 22.546875 17.292969 22.546875 17.511719 C 22.546875 17.726562 22.722656 17.902344 22.9375 17.902344 L 24.21875 17.902344 L 24.21875 18.789062 L 17.929688 18.789062 C 17.710938 18.789062 17.535156 18.964844 17.535156 19.179688 C 17.535156 19.398438 17.710938 19.570312 17.929688 19.570312 L 24.21875 19.570312 L 24.21875 20.433594 C 24.21875 20.449219 24.207031 20.460938 24.191406 20.460938 L 0.808594 20.460938 C 0.792969 20.460938 0.78125 20.449219 0.78125 20.433594 L 0.78125 19.570312 L 16.257812 19.570312 C 16.472656 19.570312 16.648438 19.398438 16.648438 19.179688 C 16.648438 18.964844 16.472656 18.789062 16.257812 18.789062 L 0.78125 18.789062 L 0.78125 17.902344 L 21.269531 17.902344 C 21.484375 17.902344 21.660156 17.726562 21.660156 17.511719 C 21.660156 17.292969 21.484375 17.117188 21.269531 17.117188 L 0.78125 17.117188 L 0.78125 16.230469 C 0.792969 16.230469 0.800781 16.230469 0.808594 16.230469 L 24.191406 16.230469 C 24.199219 16.230469 24.207031 16.230469 24.21875 16.230469 Z M 24.21875 15.421875 C 24.21875 15.4375 24.207031 15.449219 24.191406 15.449219 L 0.808594 15.449219 C 0.792969 15.449219 0.78125 15.4375 0.78125 15.421875 L 0.78125 4.566406 C 0.78125 4.550781 0.792969 4.539062 0.808594 4.539062 L 24.191406 4.539062 C 24.207031 4.539062 24.21875 4.550781 24.21875 4.566406 Z M 24.21875 15.421875 " />
                          <path d="M 22.9375 7.097656 C 22.234375 7.097656 21.660156 6.523438 21.660156 5.820312 C 21.660156 5.601562 21.484375 5.429688 21.269531 5.429688 L 16.675781 5.429688 C 16.460938 5.429688 16.285156 5.601562 16.285156 5.820312 C 16.285156 6.035156 16.457031 6.210938 16.675781 6.210938 L 20.914062 6.210938 C 21.074219 7.035156 21.722656 7.683594 22.546875 7.84375 L 22.546875 12.144531 C 21.722656 12.304688 21.074219 12.957031 20.914062 13.777344 L 16.675781 13.777344 C 16.460938 13.777344 16.285156 13.953125 16.285156 14.171875 C 16.285156 14.386719 16.460938 14.5625 16.675781 14.5625 L 21.269531 14.5625 C 21.484375 14.5625 21.660156 14.386719 21.660156 14.171875 C 21.660156 13.464844 22.234375 12.890625 22.9375 12.890625 C 23.15625 12.890625 23.328125 12.714844 23.328125 12.5 L 23.328125 7.488281 C 23.328125 7.273438 23.15625 7.097656 22.9375 7.097656 Z M 22.9375 7.097656 " />
                          <path d="M 8.324219 13.777344 L 4.085938 13.777344 C 3.925781 12.957031 3.277344 12.304688 2.453125 12.144531 L 2.453125 7.84375 C 3.277344 7.683594 3.925781 7.035156 4.085938 6.210938 L 8.324219 6.210938 C 8.539062 6.210938 8.714844 6.035156 8.714844 5.820312 C 8.714844 5.601562 8.539062 5.429688 8.324219 5.429688 L 3.730469 5.429688 C 3.515625 5.429688 3.339844 5.601562 3.339844 5.820312 C 3.339844 6.523438 2.765625 7.097656 2.0625 7.097656 C 1.84375 7.097656 1.671875 7.273438 1.671875 7.488281 L 1.671875 12.5 C 1.671875 12.714844 1.84375 12.890625 2.0625 12.890625 C 2.765625 12.890625 3.339844 13.464844 3.339844 14.171875 C 3.339844 14.386719 3.515625 14.5625 3.730469 14.5625 L 8.324219 14.5625 C 8.539062 14.5625 8.714844 14.386719 8.714844 14.171875 C 8.714844 13.953125 8.539062 13.777344 8.324219 13.777344 Z M 8.324219 13.777344 " />
                          <path d="M 12.5 5.429688 C 9.980469 5.429688 7.933594 7.476562 7.933594 9.996094 C 7.933594 12.511719 9.980469 14.5625 12.5 14.5625 C 15.019531 14.5625 17.066406 12.511719 17.066406 9.996094 C 17.066406 7.476562 15.019531 5.429688 12.5 5.429688 Z M 12.5 13.777344 C 10.414062 13.777344 8.714844 12.082031 8.714844 9.996094 C 8.714844 7.910156 10.414062 6.210938 12.5 6.210938 C 14.585938 6.210938 16.285156 7.910156 16.285156 9.996094 C 16.285156 12.082031 14.585938 13.777344 12.5 13.777344 Z M 12.5 13.777344 " />
                          <path d="M 12.890625 9.695312 L 12.890625 8.328125 C 13.449219 8.414062 13.777344 8.667969 13.777344 8.820312 C 13.777344 9.035156 13.953125 9.210938 14.171875 9.210938 C 14.386719 9.210938 14.5625 9.035156 14.5625 8.820312 C 14.5625 8.160156 13.867188 7.648438 12.890625 7.539062 L 12.890625 7.488281 C 12.890625 7.273438 12.714844 7.097656 12.5 7.097656 C 12.285156 7.097656 12.109375 7.273438 12.109375 7.488281 L 12.109375 7.539062 C 11.132812 7.648438 10.4375 8.160156 10.4375 8.820312 C 10.4375 9.738281 11.355469 10.085938 12.109375 10.296875 L 12.109375 11.660156 C 11.550781 11.574219 11.222656 11.320312 11.222656 11.167969 C 11.222656 10.953125 11.046875 10.777344 10.828125 10.777344 C 10.613281 10.777344 10.4375 10.953125 10.4375 11.167969 C 10.4375 11.828125 11.132812 12.34375 12.109375 12.453125 L 12.109375 12.5 C 12.109375 12.714844 12.285156 12.890625 12.5 12.890625 C 12.714844 12.890625 12.890625 12.714844 12.890625 12.5 L 12.890625 12.453125 C 13.867188 12.34375 14.5625 11.828125 14.5625 11.167969 C 14.5625 10.25 13.644531 9.902344 12.890625 9.695312 Z M 12.109375 9.476562 C 11.457031 9.273438 11.222656 9.089844 11.222656 8.820312 C 11.222656 8.667969 11.550781 8.414062 12.109375 8.328125 Z M 12.890625 11.660156 L 12.890625 10.511719 C 13.542969 10.71875 13.777344 10.902344 13.777344 11.167969 C 13.777344 11.320312 13.449219 11.574219 12.890625 11.660156 Z M 12.890625 11.660156 " />
                        </g>
                      </svg>
                    </div>

                    <div
                      v-if="quickViewItem.tipo_beneficio === 'F'"
                      class="icon_tipo_beneficio icon_position"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="22pt"
                        height="22pt"
                        viewBox="0 0 25 25"
                        version="1.1"
                      >
                        <g id="surface1">
                          <path d="M 23.25 11.296875 L 22.601562 8.707031 C 22.78125 8.667969 22.914062 8.511719 22.914062 8.324219 L 22.914062 7.90625 C 22.914062 7 22.175781 6.261719 21.269531 6.261719 L 18.320312 6.261719 L 18.320312 5.402344 C 18.320312 4.957031 17.957031 4.59375 17.511719 4.59375 L 2.480469 4.59375 C 2.03125 4.59375 1.671875 4.957031 1.671875 5.402344 L 1.671875 12.5 C 1.671875 12.714844 1.84375 12.890625 2.0625 12.890625 C 2.277344 12.890625 2.453125 12.714844 2.453125 12.5 L 2.453125 5.402344 C 2.453125 5.386719 2.464844 5.375 2.480469 5.375 L 17.511719 5.375 C 17.523438 5.375 17.535156 5.386719 17.535156 5.402344 L 17.535156 12.5 C 17.535156 12.714844 17.710938 12.890625 17.929688 12.890625 C 18.144531 12.890625 18.320312 12.714844 18.320312 12.5 L 18.320312 12.054688 L 22.9375 12.054688 C 23.507812 12.058594 23.988281 12.429688 24.15625 12.945312 L 22.9375 12.945312 C 22.722656 12.945312 22.546875 13.117188 22.546875 13.335938 L 22.546875 14.171875 C 22.546875 14.847656 23.097656 15.398438 23.773438 15.398438 L 24.21875 15.398438 L 24.21875 17.117188 L 23.195312 17.117188 C 22.855469 16.148438 21.933594 15.449219 20.851562 15.449219 C 19.765625 15.449219 18.84375 16.148438 18.507812 17.117188 L 18.320312 17.117188 L 18.320312 14.171875 C 18.320312 13.953125 18.144531 13.777344 17.929688 13.777344 C 17.710938 13.777344 17.535156 13.953125 17.535156 14.171875 L 17.535156 17.117188 L 9.414062 17.117188 C 9.078125 16.148438 8.15625 15.449219 7.070312 15.449219 C 5.988281 15.449219 5.066406 16.148438 4.730469 17.117188 L 2.480469 17.117188 C 2.464844 17.117188 2.453125 17.105469 2.453125 17.09375 L 2.453125 16.230469 L 4.148438 16.230469 C 4.367188 16.230469 4.539062 16.054688 4.539062 15.839844 C 4.539062 15.625 4.367188 15.449219 4.148438 15.449219 L 0.390625 15.449219 C 0.175781 15.449219 0 15.625 0 15.839844 C 0 16.054688 0.175781 16.230469 0.390625 16.230469 L 1.671875 16.230469 L 1.671875 17.09375 C 1.671875 17.539062 2.03125 17.902344 2.480469 17.902344 L 4.59375 17.902344 C 4.59375 17.910156 4.59375 17.917969 4.59375 17.929688 C 4.59375 19.292969 5.703125 20.40625 7.070312 20.40625 C 8.4375 20.40625 9.550781 19.292969 9.550781 17.929688 C 9.550781 17.917969 9.550781 17.910156 9.550781 17.902344 L 18.371094 17.902344 C 18.371094 17.910156 18.371094 17.917969 18.371094 17.929688 C 18.371094 19.292969 19.484375 20.40625 20.851562 20.40625 C 22.21875 20.40625 23.328125 19.292969 23.328125 17.929688 C 23.328125 17.917969 23.328125 17.910156 23.328125 17.902344 L 24.609375 17.902344 C 24.824219 17.902344 25 17.726562 25 17.511719 L 25 13.335938 C 25 12.304688 24.238281 11.449219 23.25 11.296875 Z M 18.320312 7.046875 L 21.269531 7.046875 C 21.742188 7.046875 22.128906 7.433594 22.128906 7.90625 L 22.128906 7.933594 L 18.320312 7.933594 Z M 18.320312 11.273438 L 18.320312 8.714844 L 21.796875 8.714844 L 22.4375 11.273438 Z M 7.070312 19.625 C 6.136719 19.625 5.375 18.863281 5.375 17.929688 C 5.375 16.992188 6.136719 16.230469 7.070312 16.230469 C 8.007812 16.230469 8.769531 16.992188 8.769531 17.929688 C 8.769531 18.863281 8.007812 19.625 7.070312 19.625 Z M 20.851562 19.625 C 19.914062 19.625 19.15625 18.863281 19.15625 17.929688 C 19.15625 16.992188 19.914062 16.230469 20.851562 16.230469 C 21.785156 16.230469 22.546875 16.992188 22.546875 17.929688 C 22.546875 18.863281 21.785156 19.625 20.851562 19.625 Z M 24.21875 14.613281 L 23.773438 14.613281 C 23.527344 14.613281 23.328125 14.414062 23.328125 14.171875 L 23.328125 13.726562 L 24.21875 13.726562 Z M 24.21875 14.613281 " />
                          <path d="M 7.070312 17.117188 C 6.625 17.117188 6.261719 17.480469 6.261719 17.929688 C 6.261719 18.375 6.625 18.738281 7.070312 18.738281 C 7.519531 18.738281 7.882812 18.375 7.882812 17.929688 C 7.882812 17.480469 7.519531 17.117188 7.070312 17.117188 Z M 7.070312 17.117188 " />
                          <path d="M 20.851562 17.117188 C 20.40625 17.117188 20.042969 17.480469 20.042969 17.929688 C 20.042969 18.375 20.40625 18.738281 20.851562 18.738281 C 21.296875 18.738281 21.660156 18.375 21.660156 17.929688 C 21.660156 17.480469 21.296875 17.117188 20.851562 17.117188 Z M 20.851562 17.117188 " />
                          <path d="M 16.257812 15.449219 L 10.414062 15.449219 C 10.195312 15.449219 10.019531 15.625 10.019531 15.839844 C 10.019531 16.054688 10.195312 16.230469 10.414062 16.230469 L 16.257812 16.230469 C 16.472656 16.230469 16.648438 16.054688 16.648438 15.839844 C 16.648438 15.625 16.472656 15.449219 16.257812 15.449219 Z M 16.257812 15.449219 " />
                          <path d="M 6.238281 13.777344 L 1.226562 13.777344 C 1.011719 13.777344 0.835938 13.953125 0.835938 14.171875 C 0.835938 14.386719 1.011719 14.5625 1.226562 14.5625 L 6.238281 14.5625 C 6.453125 14.5625 6.628906 14.386719 6.628906 14.171875 C 6.628906 13.953125 6.453125 13.777344 6.238281 13.777344 Z M 6.238281 13.777344 " />
                          <path d="M 13.613281 8.464844 C 13.460938 8.3125 13.210938 8.3125 13.058594 8.464844 L 9.578125 11.945312 L 7.765625 10.136719 C 7.613281 9.984375 7.367188 9.984375 7.210938 10.136719 C 7.058594 10.289062 7.058594 10.535156 7.210938 10.6875 L 9.300781 12.777344 C 9.375 12.851562 9.476562 12.890625 9.578125 12.890625 C 9.675781 12.890625 9.777344 12.851562 9.855469 12.777344 L 13.613281 9.019531 C 13.765625 8.867188 13.765625 8.617188 13.613281 8.464844 Z M 13.613281 8.464844 " />
                        </g>
                      </svg>
                    </div>

                    <div
                      v-if="quickViewItem.tipo_beneficio === 'P'"
                      class="icon_tipo_beneficio icon_position"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="22pt"
                        height="22pt"
                        viewBox="0 0 25 25"
                        version="1.1"
                      >
                        <g id="surface1">
                          <path d="M 24.191406 5.429688 L 18.761719 5.429688 C 18.546875 5.429688 18.371094 5.601562 18.371094 5.820312 L 18.371094 6.238281 C 18.371094 6.480469 18.171875 6.679688 17.929688 6.679688 C 17.683594 6.679688 17.484375 6.480469 17.484375 6.238281 L 17.484375 5.820312 C 17.484375 5.601562 17.308594 5.429688 17.09375 5.429688 L 0.808594 5.429688 C 0.363281 5.429688 0 5.789062 0 6.238281 L 0 18.761719 C 0 19.210938 0.363281 19.570312 0.808594 19.570312 L 17.09375 19.570312 C 17.308594 19.570312 17.484375 19.398438 17.484375 19.179688 L 17.484375 18.761719 C 17.484375 18.519531 17.683594 18.320312 17.929688 18.320312 C 18.171875 18.320312 18.371094 18.519531 18.371094 18.761719 L 18.371094 19.179688 C 18.371094 19.398438 18.546875 19.570312 18.761719 19.570312 L 24.191406 19.570312 C 24.636719 19.570312 25 19.210938 25 18.761719 L 25 6.238281 C 25 5.789062 24.636719 5.429688 24.191406 5.429688 Z M 24.21875 18.761719 C 24.21875 18.777344 24.207031 18.789062 24.191406 18.789062 L 19.15625 18.789062 L 19.15625 18.761719 C 19.15625 18.222656 18.804688 17.765625 18.320312 17.601562 L 18.320312 17.09375 C 18.320312 16.875 18.144531 16.703125 17.929688 16.703125 C 17.710938 16.703125 17.535156 16.875 17.535156 17.09375 L 17.535156 17.601562 C 17.050781 17.765625 16.703125 18.222656 16.703125 18.761719 L 16.703125 18.789062 L 0.808594 18.789062 C 0.792969 18.789062 0.78125 18.777344 0.78125 18.761719 L 0.78125 6.238281 C 0.78125 6.222656 0.792969 6.210938 0.808594 6.210938 L 16.703125 6.210938 L 16.703125 6.238281 C 16.703125 6.777344 17.050781 7.234375 17.535156 7.398438 L 17.535156 7.90625 C 17.535156 8.125 17.710938 8.296875 17.929688 8.296875 C 18.144531 8.296875 18.320312 8.125 18.320312 7.90625 L 18.320312 7.398438 C 18.804688 7.234375 19.15625 6.777344 19.15625 6.238281 L 19.15625 6.210938 L 24.191406 6.210938 C 24.207031 6.210938 24.21875 6.222656 24.21875 6.238281 Z M 24.21875 18.761719 " />
                          <path d="M 17.929688 9.1875 C 17.710938 9.1875 17.535156 9.359375 17.535156 9.578125 L 17.535156 10.414062 C 17.535156 10.628906 17.710938 10.804688 17.929688 10.804688 C 18.144531 10.804688 18.320312 10.628906 18.320312 10.414062 L 18.320312 9.578125 C 18.320312 9.359375 18.144531 9.1875 17.929688 9.1875 Z M 17.929688 9.1875 " />
                          <path d="M 17.929688 11.691406 C 17.710938 11.691406 17.535156 11.867188 17.535156 12.082031 L 17.535156 12.917969 C 17.535156 13.132812 17.710938 13.308594 17.929688 13.308594 C 18.144531 13.308594 18.320312 13.132812 18.320312 12.917969 L 18.320312 12.082031 C 18.320312 11.867188 18.144531 11.691406 17.929688 11.691406 Z M 17.929688 11.691406 " />
                          <path d="M 17.929688 14.195312 C 17.710938 14.195312 17.535156 14.371094 17.535156 14.585938 L 17.535156 15.421875 C 17.535156 15.640625 17.710938 15.8125 17.929688 15.8125 C 18.144531 15.8125 18.320312 15.640625 18.320312 15.421875 L 18.320312 14.585938 C 18.320312 14.371094 18.144531 14.195312 17.929688 14.195312 Z M 17.929688 14.195312 " />
                          <path d="M 12.777344 8.464844 C 12.625 8.3125 12.375 8.3125 12.222656 8.464844 L 4.707031 15.980469 C 4.554688 16.132812 4.554688 16.382812 4.707031 16.535156 C 4.785156 16.609375 4.882812 16.648438 4.984375 16.648438 C 5.085938 16.648438 5.183594 16.609375 5.261719 16.535156 L 12.777344 9.019531 C 12.929688 8.867188 12.929688 8.617188 12.777344 8.464844 Z M 12.777344 8.464844 " />
                          <path d="M 6.238281 7.933594 C 5.101562 7.933594 4.175781 8.859375 4.175781 9.996094 C 4.175781 11.132812 5.101562 12.054688 6.238281 12.054688 C 7.375 12.054688 8.296875 11.132812 8.296875 9.996094 C 8.296875 8.859375 7.375 7.933594 6.238281 7.933594 Z M 6.238281 11.273438 C 5.53125 11.273438 4.957031 10.699219 4.957031 9.996094 C 4.957031 9.289062 5.53125 8.714844 6.238281 8.714844 C 6.941406 8.714844 7.515625 9.289062 7.515625 9.996094 C 7.515625 10.699219 6.941406 11.273438 6.238281 11.273438 Z M 6.238281 11.273438 " />
                          <path d="M 11.246094 12.945312 C 10.109375 12.945312 9.1875 13.867188 9.1875 15.003906 C 9.1875 16.140625 10.109375 17.066406 11.246094 17.066406 C 12.382812 17.066406 13.308594 16.140625 13.308594 15.003906 C 13.308594 13.867188 12.382812 12.945312 11.246094 12.945312 Z M 11.246094 16.285156 C 10.542969 16.285156 9.96875 15.710938 9.96875 15.003906 C 9.96875 14.300781 10.542969 13.726562 11.246094 13.726562 C 11.953125 13.726562 12.527344 14.300781 12.527344 15.003906 C 12.527344 15.710938 11.953125 16.285156 11.246094 16.285156 Z M 11.246094 16.285156 " />
                        </g>
                      </svg>
                    </div>
                  </div>
                  <h5
                    class="cor-text-benefício mb-xl-3"
                    v-text="getFrase()"
                  >
                  </h5>
                </div>
                <div class="shop-detail_info mb-0">
                  <a
                    class="product-name mb-xl-4 mb-2"
                    v-text="quickViewItem.titulo"
                  ></a>
                  <div class="col-xl-6 col-12 m-auto p-0">
                    <div class="col-lg-12 col-md-12 col-sm-12 p-0 text-center">
                      <div class="product-share text-left">
                        <div
                          v-if="(impresso && !quickViewItem.controla_estoque) || (impresso && quickViewItem.controla_estoque && quickViewItem.quantidade_estoque > 0)"
                          class="product-share text-center"
                        >
                          <h5
                            class="btn btn-primary text-white cursor-pointer bg-paginacao"
                            v-on:click="downloadVoucher()"
                          >
                            Obtenha o benefício clicando aqui
                          </h5>
                        </div>

                        <div v-else-if="cupom">
                          <p class="p-c text-left py-1 px-3">
                            Copie o cupom e aproveite:
                          </p>
                          <div>
                            <div class="text-white bg-paginacao btn-new rounded">
                              <span
                                id="CopyContent"
                                class="class-cod"
                              >
                                <input
                                  ref="input"
                                  v-model="quickViewItem.codigo"
                                  type="text"
                                  class="border-0 codInput"
                                >
                                <svg
                                  id="Layer_1"
                                  version="1.1"
                                  class="copy-icon"
                                  width="30"
                                  height="20"
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink"
                                  x="0px"
                                  y="0px"
                                  viewBox="0 0 512 512"
                                  style="enable-background:new 0 0 512 512;"
                                  xml:space="preserve"
                                  v-on:click="copyToClipboard()"
                                >
                                  <path
                                    d="M311,512H120c-44.1,0-80-35.9-80-80V161c0-44.1,35.9-80,80-80h191c44.1,0,80,35.9,80,80v271C391,476.1,355.1,512,311,512z
                                      M120,121c-22.1,0-40,17.9-40,40v271c0,22.1,17.9,40,40,40h191c22.1,0,40-17.9,40-40V161c0-22.1-17.9-40-40-40H120z M471,382V80
                                      c0-44.1-35.9-80-80-80H169c-11,0-20,9-20,20s9,20,20,20h222c22.1,0,40,17.9,40,40v302c0,11,9,20,20,20S471,393,471,382z"
                                  />
                                </svg>
                              </span>
                              <span class="copied text-center">Copiado para área de transferência!</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="online"
                        class="product-share text-left d-flex"
                      >
                        <h5
                          class="btn btn-primary text-white cursor-pointer bg-paginacao mb-1 m-auto"
                          v-on:click="goTo()"
                        >
                          Clique aqui para obter o benefício
                        </h5>
                      </div>
                      <div
                        v-if="quickViewItem.controla_estoque && quickViewItem.quantidade_estoque <= 0 && impresso"
                        class="product-share text-left d-flex"
                      >
                        <h5
                          class="btn btn-primary text-white cursor-pointer bg-paginacao"
                          style="cursor: auto"
                        >
                          Estoque indisponível
                        </h5>
                      </div>
                      <small
                        class="col-sm-12 col-md-4 col-lg-7 p-0 product-type small bottom-0 fs-9 float-xl-right mr-1"
                        v-text="'Benefício válido até: ' + quickViewItem.datafim"
                      ></small>
                    </div>
                  </div>
                  <div class="row col-12 p-xl-0 pb-3 align-self-md-end m-auto mt-xl-5">
                    <div class="col-lg-8 col-md-8 col-sm-12 mt-4 p-0 text-center text-xl-left">
                      <small>
                        <b>PROBLEMA COM O BENEFÍCIO?</b><br />
                        A validade, estoque, valor e demais condições comerciais<br />
                        podem variar sem aviso prévio conforme a disponibilidade<br />
                        dos fornecedores. Em caso de divergencia, serão válidas sempre<br />
                        as ofertas, descontos ou promoções praticadas junto ao site parceiro.<br /><b>Em caso de inconsistência, <span
                          class="cursor-pointer"
                          v-on:click="showErrorForm()"
                        >CLIQUE AQUI</span>.</b>
                      </small>
                    </div>
                    <div
                      class="col-lg-4 col-md-4 col-sm-12 mt-4 text-right p-0 align-self-md-end text-center"
                    >
                      <small>
                        <b>RASTREIO DO BENEFÍCIO</b><br />
                        Inclusão: <span v-text="quickViewItem.created_at"></span><br />
                        Verificação: <span v-text="quickViewItem.verificado_at"></span>
                      </small>
                    </div>
                  </div>
                  <div
                    v-if="showFormError"
                    class="product-share text-center box2 sb10 text-center"
                  >
                    <div
                      class="text-right"
                      style="
                            padding-top: -23px;
                            position: absolute;
                            right: 15px;
                            top: 8px;
                            cursor: pointer;
                        "
                    >
                      <i
                        class="far fa-times-circle"
                        v-on:click="closeErrorModal()"
                      ></i>
                    </div>
                    <div>
                      <p class="p-c font-weight-light">
                        Relate seu problema:
                      </p>
                      <input
                        id="frmErrorURL"
                        type="hidden"
                        name="frmErrorURL"
                        value=""
                      >
                      <!--                                                        <input id="frmErrorNome" v-model="frmErrorNome" class="form-control mb-1 custom-font-size-10" placeholder="Seu nome*">-->
                      <!--                                                        <input id="frmErrorEmail" v-model="frmErrorEmail" class="form-control mb-1 custom-font-size-10" placeholder="Seu email*">-->
                      <textarea
                        id="frmErrorDesc"
                        v-model="frmErrorDesc"
                        class="form-control mb-1 custom-font-size-10 textAreaErrorForm"
                      ></textarea>
                      <button
                        id="frmErrorButton"
                        class="btn custom-font-size-10 btn-secondary sendErrorForm"
                        v-on:click="enviaEmail()"
                      >
                        <span
                          id="loading"
                          class="spinner-border spinner-border-sm d-none"
                        ></span>Enviar
                      </button>
                      <div
                        id="frmErrorMsg"
                        class="d-none small pt-2"
                        v-text="frmErrorMsg"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.qwpt {
    padding-top: 54px;
    height: 150px;
}
</style>
<script>
import SwitchInput from '../SwitchInput';

export default {
    props: {
        showReactions: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            ButtonLikeClicked: false,
            showFormError: false,
            frmErrorDesc: '',
            frmErrorMsg: 'Enviar',
            quickViewItem: {
                likeClass: false,
                unLikeClass: false
            },
            estoque: false,
            online: false,
            cupom: false,
            impresso: false,
            loading: true
        };
    },
    components: {
        SwitchInput,
        'socket': VueLoadingSpinner.Circle
    },
    methods: {
        likeButtonForm () {
            this.showFormError = false;
            this.$set(this.quickViewItem, 'likeClass', !this.quickViewItem.likeClass);
            this.$set(this.quickViewItem, 'unLikeClass', false);
        },
        showErrorForm () {
            this.showFormError = !this.quickViewItem.unlikebtn;
            this.$set(this.quickViewItem, 'likeClass', false);
            this.$set(this.quickViewItem, 'unLikeClass', !this.quickViewItem.unlikebtn);
        },
        copyToClipboard () {
            $('.copied').css('display', 'block');
            setTimeout(function () {
                $('.copied').css('display', 'none');
            }, 2000);

            this.$refs.input.select();
            document.execCommand('copy');
            this.goTo();
        },
        checkClick (item, forceUse = true) {
            if (!window.usemodal && forceUse) {
                window.location.href = '/viewItem/' + item;
                // window.open('/viewItem/' + item);
                return;
            }

            $(this.$el).modal();
            this.quickViewItem = {};
            this.showFormError = false;
            this.$http.post('/showItem/' + item, {}).then((response) => {
                if (response.body.success) {
                    this.quickViewItem = response.body.data;

                    this.estoque = this.quickViewItem.controla_estoque && this.quickViewItem.quantidade_estoque > 0;
                    this.online = !this.quickViewItem.codigo && this.quickViewItem.tipo_midia === 'Online';
                    this.cupom = this.quickViewItem.codigo && this.quickViewItem.tipo_midia === 'Online';
                    this.impresso = this.quickViewItem.tipo_midia === 'Impresso';
                    this.loading = false;
                    // $(this.$el).modal();
                    return;
                }
                window.alertError('Item', 'Item indisponível');
            }).catch(() => {
                window.alertError('Item', 'Item indisponível');
            });
        },
        enviaEmail () {
            if (this.frmErrorDesc !== '') {
                let details = {
                    // nome: this.frmErrorNome,
                    // email: this.frmErrorEmail,
                        descricao: this.frmErrorDesc,
                        url: this.quickViewItem.url
                    }, self = this,
                    component = $('#frmErrorMsg');

                window.toggleSaveLoading(false, 'Enviado', 'frmErrorButton');
                this.$http.post(this.quickViewItem.url + '/reportError', details).then((response) => {
                    component.removeClass('d-none');
                    if (response.body.success) {
                        window.toggleSaveLoading(true, 'Enviado!', 'frmErrorButton');
                        self.frmErrorMsg = response.data.message;
                        return;
                    }
                    window.toggleSaveLoading(false, 'Enviado!', 'frmErrorButton');
                    self.frmErrorMsg = response.data.message;
                }).catch(() => {
                    window.toggleSaveLoading(false, 'Enviar', 'frmErrorButton');
                    self.frmErrorMsg = 'Erro ao enviar! Por favor tente novamente!';
                });
            }
        },
        downloadVoucher () {
            window.open('/voucher/' + this.quickViewItem.url, '_blank');
            $(this.$el).modal('hide');
        },
        goTo () {
            window.open(this.quickViewItem.link, '_blank');
        },
        getLikeClass () {
            return {
                'likebtn': true,
                'like-selected': this.quickViewItem.likeClass
            };
        },
        getUnlikeClass () {
            return {
                'unlikebtn': true,
                'dislike-selected': this.quickViewItem.unLikeClass
            };
        },
        setColumn (column) {
            this.$http.post(`/app/cupons/${this.quickViewItem.url}/updateColumn`, {column}).then((response) => {
                if (response.body.success) {
                    window.alertSuccess('Benefícios', response.body.message, '', true);
                    return;
                }

                window.alertError('Benefícios', response.body.message);
            }).catch(() => {
                window.alertError('Benefícios', 'Ocorreu um erro, favor tentar novamente.');
            });
        },
        getFrase () {
            let base = '';

            if (this.quickViewItem.verificado) {
                base = 'Este benefício foi analisado por uma pessoa do nosso time';
            }
            // let base = 'Este benefício foi analisado por uma pessoa do nosso time e oferece';

            if (this.quickViewItem.tipo_beneficio === 'V') {
                base = base + ((this.quickViewItem.verificado) ? ' e ' : 'Este benefício ');
                return base + 'oferece desconto real em dinheiro';
            }

            if (this.quickViewItem.tipo_beneficio === 'P') {
                base = base + ((this.quickViewItem.verificado) ? ' e ' : 'Este benefício ');
                return base + 'oferece percentual de desconto';
            }

            if (this.quickViewItem.tipo_beneficio === 'F') {
                base = base + ((this.quickViewItem.verificado) ? ' e ' : 'Este benefício ');
                return base + 'oferece frete grátis';
            }
        },
        closeErrorModal () {
            this.showFormError = false;
        }
    }
};
</script>
